<template>
  <div class="my-bar">
    <span class="star"></span>
    <span class="title">我的学习信息</span>
    <span class="star"></span>

    <div class="content-items">
      <div class="content-item-1">
        <p class="num">{{ myInfo.score || 0 }}</p>
        <p class="info-name">学习热度<span class="info-icon" @click="showScoreTip"></span></p>
      </div>
      <div class="content-item-1">
        <p class="num">
          {{ Number(myInfo.rank_no > 9999) ? "9999+" : myInfo.rank_no || "--" }}
        </p>
        <p class="info-name">总排名</p>
      </div>
      <div class="content-item-1">
        <p class="num">{{ myInfo.study_num || 0 }}</p>
        <p class="info-name">视频观看量/个</p>
      </div>
      <div class="content-item-1">
        <p class="num">{{ myInfo.app_days || 0 }}</p>
        <p class="info-name">APP打卡天数</p>
      </div>
      <div class="content-item-1">
        <p class="num">{{ myInfo.pc_days || 0 }}</p>
        <p class="info-name">PC打卡天数</p>
      </div>
      <div class="content-item-1">
        <p class="num">{{ myInfo.invites || 0 }}</p>
        <p class="info-name">邀请人数</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyInfo",
  props: {
    myInfo: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods:{
    showScoreTip(){
      this.$emit('showScoreTip')
    }
  }
};
</script>
<style lang="scss" scoped>
.info-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
  background: url("~@/assets/activity/learningStar/info.png") 50% 50% no-repeat;
  background-size: contain;
  cursor: pointer;
}
.my-bar {
  background: #f3f6ff;
  border: 1px solid rgba(35, 64, 176, 1);
  border-radius: 2px 0px 0px 2px;
  display: flex;
  padding: 0 20px;
  height: 92px;
  align-items: center;
  // justify-content: space-between;
  .title {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 24px;
    color: #2340b0;
  }
  .star {
    width: 60px;
    height: 53px;
    margin: 0 10px;
    background: url("~@/assets/activity/learningStar/love.png") no-repeat center
      center;
    background-size: contain;
  }

  .num {
    font-family: AlibabaPuHuiTi-Medium;
    font-size: 30px;
    color: #2340b0;
    text-align: center;
    font-weight: 500;
    line-height: 32px;
  }
  .info-name {
    font-family: AlibabaPuHuiTi-Regular;
    font-size: 16px;
    color: #5c79e6;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-items {
    width: 760px;
    display: flex;
    padding-left: 52px;
    justify-content: space-between;
  }
  // .content-item-1 {
  //   width: 160px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/activities/learningStar/components/myInfo.vue